export default __webpack_public_path__ + "static/media/ic-announcements-text.b662417a.svg";